export enum OrderOptimizerListItemStatus {
  PENDING = "PENDING",
  INTERESTING = "INTERESTING",
  REJECTED = "REJECTED",
}

export type OrderOptimizerListItemOrders = {
  humanId: number;
  startTime: Date;
  cargoCompany: string;
  taxiCorporation: string;
  haltingTimeBefore: number;
};

export type OrderOptimizerListItemRoute = {
  orderHumanId: number;
  lat: number;
  lon: number;
};

export type OrderOptimizerListItem = {
  id: string;
  score: number;
  status: OrderOptimizerListItemStatus;
  route: OrderOptimizerListItemRoute[];
  orders: OrderOptimizerListItemOrders[];
  reviewedBy: string | null;
  reviewedAt: Date | null;
};

type OrderOptimizerList = {
  data: OrderOptimizerListItem[];
  totalCount: number;
};

export default OrderOptimizerList;
